import { render, staticRenderFns } from "./ClipPlayerStudio.vue?vue&type=template&id=580aa208&scoped=true&"
import script from "./ClipPlayerStudio.vue?vue&type=script&lang=ts&"
export * from "./ClipPlayerStudio.vue?vue&type=script&lang=ts&"
import style0 from "./ClipPlayerStudio.vue?vue&type=style&index=0&id=580aa208&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580aa208",
  null
  
)

export default component.exports